import { Grid } from "@mui/material";
import { BookingId, MainDetails, OtherDetails, PaymentDetails, SubscriptionDetails, SubstitutionDetails } from "./sections";

const TabBookingEntity = () => {

    return (
        <Grid container spacing={2} alignItems="start">
            <Grid item container xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <BookingId />
                </Grid>
                <Grid item xs={12}>
                    <OtherDetails />
                </Grid>
            </Grid>
            <Grid item container xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <MainDetails />
                </Grid>
                <Grid item xs={12}>
                    <SubstitutionDetails />
                </Grid>
                <Grid item xs={12}>
                    <SubscriptionDetails />
                </Grid>
                <Grid item xs={12}>
                    <PaymentDetails />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default TabBookingEntity;
